<template lang="pug">
    include ../../media/pug/mixins
    +b.mark(
        v-bind:style="markStyles"
        v-bind:class="{'mark_is_active' : isActive}"
    )
        +e.box
            +e.BUTTON.box.btn(
                v-on:click="edit"
                v-on:touchstart="edit"
                v-bind:style="markBoxStyles"
            )
                v-icon(
                    v-bind:name="type"
                )
            +e.BUTTON.delete.btn(
                v-if="isActive && !isMobile && !isAddMarkMode"
                type="button"
                v-on:click="remove"
            )
                v-icon(name="close-wide")

        +e.popover.tooltip(
            v-if="isActive && !isMobile"
            v-bind:style="{top: `${popover.y}px`, left: `${popover.x}px`}"
        )
            +e.INPUT.input.input(
                type="text"
                placeholder="Название заметки"
                v-bind:value="text"
                v-on:blur="changeText"
                v-on:keyup.enter="changeText"
                ref="field"
            )

</template>


<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        type: {
            type: String,
            default: 'mark'
        },
        popover: {
            type: Object,
            default: () => ({
                x: null,
                y: 0
            }),
            required: true
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        boxWidth: {
            type: Number,
            required: true,
            default: 0
        },
        boxHeight: {
            type: Number,
            required: true,
            default: 0
        },
        text: {
            type: String,
            required: true,
            default: ''
        },
        isActive: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
            value: ''
        };
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'getZoom',
            'isAddMarkMode',
            'isMarkConfirmed',
            'isMarkEditMode'
        ]),
        markBoxStyles() {
            return {
                width: `${this.boxWidth}px`,
                height: `${this.boxHeight}px`
            };
        },
        markStyles() {
            return {
                top: `${this.y}px`,
                left: `${this.x}px`,
                transform: `
                    rotate(${-(this.$route.query.rotate)}deg)
                    `
            };
        }
    },
    watch: {
        isMarkConfirmed(val) {
            if (!this.isMobile) {
                if (val) {
                    this.changeText();
                }
            }
            if (val !== null && this.isActive) {
                this.$emit('confirm', val);
            }
        }
    },
    methods: {
        remove() {
            this.$store.dispatch('showModal', 'ModalRemoveMark');
        },
        changeText() {
            if (this.isActive) { this.$emit('change-text', this.$refs.field.value); }
        },
        edit() {
            if (!this.isAddMarkMode) {
                this.$emit('edit');
            }
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/document-views/document-view-img-mark.sass"></style>
